import { useEffect, useState } from "react";

function currentTime(): string {
  return new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

/** Current local time as HH:MM, refreshed every minute. */
export function useClock(): string {
  const [time, setTime] = useState(currentTime);
  useEffect(() => {
    const id = setInterval(() => setTime(currentTime()), 60_000);
    return () => clearInterval(id);
  }, []);
  return time;
}
